// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.-oneX--scrim__modal {
    background-color: rgba(0,0,0,0.75)
}
.lr-heading {
    text-align: center;
    margin-bottom: 32px;
}
.lr-center {
    text-align: center;
    /* padding-top: 8px; */
}
.lr-btn-prime {
    /* margin-bottom: 16px; */
}

@media(min-width: 768px) {
    .lr-heading {
        font-size: 23px;
    }
}

.olr-modal {
  display: none;
  align-content: center;
}

.olr-modal-content-padding {
    padding: 32px;
}

.olr-auto-left {
    left: auto;
}

.saveExitHeader {
    color: var(--core-charcoal-403-c-3-c, #403C3C);
 
    /* Customer headings/desktop/H2/SemiBold (default) */
    font-family: "Mecherle Sans";
    font-size: 39px;
    font-style: normal;
    font-weight: 600;
    line-height: 39px; /* 100% */
}
.saveExitMargin1 {
    margin-bottom: 24px;
    padding: 0px !important;
}
.saveExitMargin2 {
    margin-right: 16px;
}
.saveExitFlex {
    display: inline-flex !important;
}
@media(max-width: 400px) {
    .saveExitHeader {
        color: var(--core-charcoal-403-c-3-c, #403C3C);
 
/* Customer headings/mobile/H2/SemiBold (default) */
font-family: "Mecherle Sans";
font-size: 25px;
font-style: normal;
font-weight: 600;
line-height: 25px; /* 100% */
        
    }
} 
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/shared/progress/save/save.component.css"],"names":[],"mappings":"AAAA;IACI;AACJ;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,8CAA8C;;IAE9C,oDAAoD;IACpD,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;AAChC;AACA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,+BAA+B;AACnC;AACA;IACI;QACI,8CAA8C;;AAEtD,mDAAmD;AACnD,4BAA4B;AAC5B,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,SAAS;;IAExB;AACJ","sourcesContent":[".-oneX--scrim__modal {\n    background-color: rgba(0,0,0,0.75)\n}\n.lr-heading {\n    text-align: center;\n    margin-bottom: 32px;\n}\n.lr-center {\n    text-align: center;\n    /* padding-top: 8px; */\n}\n.lr-btn-prime {\n    /* margin-bottom: 16px; */\n}\n\n@media(min-width: 768px) {\n    .lr-heading {\n        font-size: 23px;\n    }\n}\n\n.olr-modal {\n  display: none;\n  align-content: center;\n}\n\n.olr-modal-content-padding {\n    padding: 32px;\n}\n\n.olr-auto-left {\n    left: auto;\n}\n\n.saveExitHeader {\n    color: var(--core-charcoal-403-c-3-c, #403C3C);\n \n    /* Customer headings/desktop/H2/SemiBold (default) */\n    font-family: \"Mecherle Sans\";\n    font-size: 39px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 39px; /* 100% */\n}\n.saveExitMargin1 {\n    margin-bottom: 24px;\n    padding: 0px !important;\n}\n.saveExitMargin2 {\n    margin-right: 16px;\n}\n.saveExitFlex {\n    display: inline-flex !important;\n}\n@media(max-width: 400px) {\n    .saveExitHeader {\n        color: var(--core-charcoal-403-c-3-c, #403C3C);\n \n/* Customer headings/mobile/H2/SemiBold (default) */\nfont-family: \"Mecherle Sans\";\nfont-size: 25px;\nfont-style: normal;\nfont-weight: 600;\nline-height: 25px; /* 100% */\n        \n    }\n} \n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
